
import CompoundEditComponent from "../../../components/compounds/Edit.vue";

export default {
  components: {
    CompoundEditComponent
  }
}
